import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useController } from '@/hooks/useController';
import { WebviewContainer } from '@/newComponents/Message/Webview/WebviewContainer';
import { webviewModalState } from '@/state/session';
const image = '../../../../public/webview-image.png';
export const WebviewResponse = ({ webview, onButtonClick }) => {
    const { label, height, name } = webview;
    const [isWebviewExpanded, setIsWebviewExpanded] = useState(false);
    const setWebviewModal = useSetRecoilState(webviewModalState);
    const { notifyWebviewClosed, notifyWebviewOpened } = useController();
    const handleWebviewClose = () => {
        setIsWebviewExpanded(false);
        notifyWebviewClosed();
    };
    const handleWebviewClick = () => {
        onButtonClick({ type: 'webview_button', label, value: name });
        if (height === 'compact') {
            setWebviewModal(webview);
        }
        else {
            notifyWebviewOpened();
            setIsWebviewExpanded(true);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cn('dark:border-input bg-background flex max-w-sm flex-col justify-between overflow-hidden rounded-xl border border-gray-200'), children: [_jsxs("div", { className: "flex-grow", children: [_jsx("div", { className: "h-40 w-full", children: _jsx("img", { src: image, alt: name, className: "h-full w-full object-cover" }) }), _jsx("div", { className: "px-4 pt-2", children: _jsx("h4", { className: "text-foreground mb-1 line-clamp-2 overflow-hidden text-lg leading-7 font-medium", children: name }) })] }), _jsx("div", { className: "mt-2 flex flex-col justify-end px-4 pb-4", children: _jsx(Button, { onClick: handleWebviewClick, children: label }) })] }), isWebviewExpanded && (_jsx(Dialog, { open: true, children: _jsx(DialogContent, { onInteractOutside: (e) => e.preventDefault(), onEscapeKeyDown: (e) => e.preventDefault(), className: cn('h-full w-full p-0', {
                        'h-[var(--moveo-modal-tall-height)] w-[var(--moveo-modal-tall-width)]': height === 'tall',
                    }), children: _jsx(WebviewContainer, { webview: webview, onClick: handleWebviewClose }) }) }))] }));
};
